// src/components/Navbar.js

import React, { useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css"; // Asegúrate de tener el archivo CSS para los estilos
import {
  FaHome,
  FaPlusSquare,
  FaSignOutAlt,
  FaShoppingCart,
  FaThLarge, // Importamos FaThLarge
  FaBullhorn // Importamos el ícono de megáfono para el anuncio
} from "react-icons/fa";
import { CartContext } from "../contexts/CartContext"; // Importamos el contexto del carrito

const Navbar = ({ isAuthenticated, isAdmin, setIsAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Obtenemos los items del carrito
  const { cartItems } = useContext(CartContext);

  // Calculamos el total de cantidades en el carrito
  const totalQuantity = cartItems.reduce((total, item) => total + item.quantity, 0);

  const handleLogout = () => {
    localStorage.removeItem("token"); // Elimina el token
    localStorage.removeItem("isAdmin"); // Elimina el estado de administrador
    setIsAuthenticated(false); // Cambia el estado de autenticación
    navigate("/"); // Redirige a la página de inicio
  };

  // Función para manejar el clic en "Inicio"
  const handleHomeClick = () => {
    navigate("/", { state: { reset: true } });
  };

  return (
    <>
      {isAuthenticated && (
        <nav className="bottom-navbar">
          {/* Botón "Inicio" que navega programáticamente con estado */}
          <button
            type="button"
            onClick={handleHomeClick}
            className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
          >
            <FaHome className="nav-icon" />
            <span>Inicio</span>
          </button>

          {/* Enlace al carrito de compras */}
          <Link
            to="/cart"
            className={location.pathname === "/cart" ? "active" : ""}
          >
            <div className="cart-icon-container">
              <FaShoppingCart className="nav-icon" />
              {totalQuantity > 0 && (
                <span className="cart-count">{totalQuantity}</span>
              )}
            </div>
            <span>Carrito</span>
          </Link>

          {isAdmin && (
            <>
              <Link
                to="/create-product"
                className={
                  location.pathname === "/create-product" ? "active" : ""
                }
              >
                <FaPlusSquare className="nav-icon" />
                <span>Agregar</span>
              </Link>

              {/* Enlace a la gestión de categorías */}
              <Link
                to="/create-category"
                className={location.pathname === "/create-category" ? "active" : ""}
              >
                <FaThLarge className="nav-icon" />
                <span>Categorías</span>
              </Link>

              {/* Enlace a la creación de anuncio */}
              <Link
                to="/create-ad"
                className={location.pathname === "/create-ad" ? "active" : ""}
              >
                <FaBullhorn className="nav-icon" />
                <span>Anuncio</span>
              </Link>
            </>
          )}

          <button onClick={handleLogout} className="logout-button">
            <FaSignOutAlt className="nav-icon" />
            <span>Salir</span>
          </button>
        </nav>
      )}
    </>
  );
};

export default Navbar;
